export type Photo = {
  uuid: string;
  url: string;
  width: number;
  height: number;
  color: string;
};

export type Photos = {
  collection: Photo[];
  order: string[];
};

export type PhotosDownload = Photos;

export type PhotosUpload = {
  order: string[]
};

export const emptyPhotos = () => ({collection: [], order: []}) as Photos;

export const photosFromApi = (p: PhotosDownload) => p as Photos;

export const photosToApi = ({ order }: Photos) => ({order}) as PhotosUpload;

export const featuredPhoto = ({ collection, order }: Photos) => (
    (order.length && collection.find(i => i.uuid === order[0])) || null
) as Photo | null;

export const photoList = ({ collection, order }: Photos) => (
    order.map(uuid => collection.find(i => i.uuid === uuid))
) as [Photo];
